import React from 'react';
import './chatMode.css';
import chatIcon from '../assets/chat-icon.svg'; // Ensure you have an icon
import { IoChatbubblesOutline } from "react-icons/io5";
import {FiHeart, FiMessageSquare} from "react-icons/fi"

const ChatModeSelectionModal = ({ onSelect, onClose }) => {
    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-button" onClick={onClose}>✖</button>
                <IoChatbubblesOutline alt="Chat Icon" className="chat-icon" size={44} color='white' />
                <h2>Select Chat Mode</h2>
                <div className="chat-mode-buttons">
                    <button onClick={() => onSelect('answerChat')} className="chat-mode-button-answer">
                    <FiMessageSquare/>  Direct Answers
                    </button>
                    <button onClick={() => onSelect('standard')} className="chat-mode-button">
                    <FiHeart className='heart-ico'/>  Deeper Conversations
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ChatModeSelectionModal;
